export const STAFFS_PENDING = 'STAFFS_PENDING';
export const STAFFS_REJECTED = 'STAFFS_REJECTED';
export const FETCH_STAFFS_FULFILLED = 'FETCH_STAFFS_FULFILLED';
export const ACTIVATE_STAFF_FULFILLED = 'ACTIVATE_STAFF_FULFILLED';
export const ACTIVATE_STAFF_REJECTED = 'ACTIVATE_STAFF_REJECTED';
export const LOGIN_SUCCESS = 'LOGIN_SUCCESS';
export const CURRENT_STAFF_FULFILLED = 'CURRENT_STAFF_FULFILLED';



// WEBPACK FOOTER //
// ./src/constants/staffs.js